"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { Card } from "@components/common/card";
import { dateString } from "@lib/dates";
import { partyBackgroundHover, partyBorderBottom, partyMarker, partyTextColor } from "@lib/styles/party";
import type { Standpoint } from "@partiguiden/party-data/types";
import type { Party } from "@partiguiden/party-data/types";
import { partyNames } from "@partiguiden/party-data/utils";
interface PartyStandpointsProps {
  party: Party;
  standpoints: Standpoint[];
}
export default function PartyStandpoints(t0) {
  const $ = _c(15);
  const {
    party,
    standpoints
  } = t0;
  const [visible, setVisible] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleClick() {
      setVisible(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClick = t1;
  const t2 = partyBorderBottom[party];
  let t3;
  if ($[1] !== t2) {
    t3 = twMerge(t2, "font-light group flex w-full items-center justify-between border-b-2 py-3 pl-2 text-start text-3xl");
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = partyNames[party];
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChevronDownIcon className="mr-2 h-6 w-6 transition-transform duration-300 group-aria-expanded:rotate-180" />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t3 || $[5] !== t4 || $[6] !== visible) {
    t6 = <button onClick={handleClick} aria-expanded={visible} className={t3}>{t4}{t5}</button>;
    $[4] = t3;
    $[5] = t4;
    $[6] = visible;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== party || $[9] !== standpoints || $[10] !== visible) {
    t7 = visible && <div className="flex flex-col gap-3">{standpoints.map(standpoint => <Card key={standpoint.url} className="flex flex-col gap-5"><p className="text-2xl">{standpoint.title}</p>{standpoint.opinions.length === 0 && <p>Inga ståndpunkter hittades</p>}{standpoint.opinions.length === 1 && <p>{standpoint.opinions[0]}</p>}{standpoint.opinions.length > 1 && <ul className={`${partyMarker[party]} ml-4 flex list-disc flex-col gap-3`}>{standpoint.opinions.map(_temp2)}</ul>}<div className="flex flex-wrap"><a className={twMerge("whitespace-nowrap rounded-sm p-2 text-sm font-medium uppercase transition-colors", partyTextColor[party], partyBackgroundHover[party])} target="_blank" rel="noopener noreferrer" href={standpoint.url}>Läs mer på partiets hemsida</a><span className="ml-auto self-end whitespace-nowrap text-xs sm:text-sm">Datan uppdaterades {dateString(standpoint.updateDate)}</span></div></Card>)}</div>;
    $[8] = party;
    $[9] = standpoints;
    $[10] = visible;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp2(opinion) {
  return <li key={opinion}>{opinion}</li>;
}
function _temp(prevState) {
  return !prevState;
}